import { useTranslations } from 'next-intl';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';

export interface ViewPaginationLabelProps {
  pageSize: number;
  currentPage: number;
  productCount: number;
}

export const ViewPaginationLabel = ({
  pageSize,
  currentPage,
  productCount
}: ViewPaginationLabelProps) => {
  const t = useTranslations();
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const viewCountTranslations = isLG
    ? 'VIEWING_COUNT'
    : 'CATEGORY_RESULTS_PAGES';

  const viewingPaginationLabel = ({ pageSize, currentPage, productCount }) =>
    t(viewCountTranslations, {
      0: `${currentPage * pageSize - pageSize + 1} -
      ${currentPage * pageSize < productCount ? currentPage * pageSize : productCount}`,
      1: `${productCount}`
    });

  return (
    <label slot={isLG ? 'label' : 'inpage-label'}>
      {viewingPaginationLabel({ pageSize, currentPage, productCount })}
    </label>
  );
};
